export default __webpack_public_path__ + "static/media/instant-set-image.ecc4b2ae.svg";